import { useEffect, useState } from 'react';
import './Modal.css';

const Modal = (props) => {
    const { message,timeOuts, closeModal, downloadExcel } = props;

    const [timer, setTimer] = useState(message && timeOuts ? timeOuts : 31);

    const [downloadingExcel, setDownloadingExcel] = useState();
    
    const refreshPage = (timeOuts) => {
        closeModal()
        if(timeOuts == 'statement_generated'){
            window.location.reload()
            // TODO:
            // find the function which is loading the data in table and that excel button and call it
        }
    }

    const startTimer = () => {
        setTimer(timer => {
            if(timer == 1){
                // closeModal();
            }
            else{
                setTimeout(() => {
                    startTimer();
                }, 1000);
            }
            return timer-1;
        });
    };
    
    useEffect(() => {
        if(!message || (message && !message.isError)){
            startTimer();
        }
    }, []);

    return ( 
        <div id="myModal" className="modal" onClick={(e) => {return; if(e.target == document.getElementById("myModal")) closeModal(); }}>
            <div className="modal-content">
                <span className="close" onClick={() => refreshPage(timeOuts)}>&times;</span>
                <p>
                    {
                        message.isError
                         ? `Error: ${message.detail}`
                         : ( (timer > 0 && timeOuts !== 'statement_generated') ? `${message.message1}, please wait for ${timer} seconds` : `${message.message2}, Please Download` )
                    }
                </p>
                {
                    (timer == 0 || timeOuts == 'statement_generated') && (
                        <div className={`export-csv-btn download-excel-modal ${downloadingExcel ? 'export-csv-btn-downloading' : ''}`} onClick={() => downloadExcel()}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0007 7.21337C11.8238 7.21337 11.6543 7.28361 11.5292 7.40864C11.4042 7.53366 11.334 7.70323 11.334 7.88004V12.6667C11.334 12.8435 11.2637 13.0131 11.1387 13.1381C11.0137 13.2631 10.8441 13.3334 10.6673 13.3334H3.33398C3.15717 13.3334 2.9876 13.2631 2.86258 13.1381C2.73756 13.0131 2.66732 12.8435 2.66732 12.6667V5.33337C2.66732 5.15656 2.73756 4.98699 2.86258 4.86197C2.9876 4.73695 3.15717 4.66671 3.33398 4.66671H8.12065C8.29746 4.66671 8.46703 4.59647 8.59206 4.47144C8.71708 4.34642 8.78732 4.17685 8.78732 4.00004C8.78732 3.82323 8.71708 3.65366 8.59206 3.52864C8.46703 3.40361 8.29746 3.33337 8.12065 3.33337H3.33398C2.80355 3.33337 2.29484 3.54409 1.91977 3.91916C1.5447 4.29423 1.33398 4.80294 1.33398 5.33337V12.6667C1.33398 13.1971 1.5447 13.7058 1.91977 14.0809C2.29484 14.456 2.80355 14.6667 3.33398 14.6667H10.6673C11.1978 14.6667 11.7065 14.456 12.0815 14.0809C12.4566 13.7058 12.6673 13.1971 12.6673 12.6667V7.88004C12.6673 7.70323 12.5971 7.53366 12.4721 7.40864C12.347 7.28361 12.1775 7.21337 12.0007 7.21337ZM14.614 1.74671C14.5463 1.58381 14.4169 1.45436 14.254 1.38671C14.1738 1.35255 14.0878 1.33443 14.0007 1.33337H10.0007C9.82384 1.33337 9.65427 1.40361 9.52925 1.52864C9.40422 1.65366 9.33398 1.82323 9.33398 2.00004C9.33398 2.17685 9.40422 2.34642 9.52925 2.47145C9.65427 2.59647 9.82384 2.66671 10.0007 2.66671H12.394L5.52732 9.52671C5.46483 9.58868 5.41524 9.66242 5.38139 9.74366C5.34754 9.82489 5.33012 9.91203 5.33012 10C5.33012 10.088 5.34754 10.1752 5.38139 10.2564C5.41524 10.3377 5.46483 10.4114 5.52732 10.4734C5.58929 10.5359 5.66303 10.5855 5.74427 10.6193C5.82551 10.6531 5.91264 10.6706 6.00065 10.6706C6.08866 10.6706 6.1758 10.6531 6.25704 10.6193C6.33827 10.5855 6.41201 10.5359 6.47398 10.4734L13.334 3.60671V6.00004C13.334 6.17685 13.4042 6.34642 13.5292 6.47144C13.6543 6.59647 13.8238 6.66671 14.0007 6.66671C14.1775 6.66671 14.347 6.59647 14.4721 6.47144C14.5971 6.34642 14.6673 6.17685 14.6673 6.00004V2.00004C14.6663 1.91292 14.6481 1.82686 14.614 1.74671Z" fill="white"/>
                            </svg>
                            Download Excel
                        </div>
                    )
                }
            </div>
        </div>
     );
}
 
export default Modal;